import { MarkfedLogin } from './Login';

export { MarkfedLogin } from './Login';
export default MarkfedLogin;